module.exports = __webpack_public_path__ + "img/pinball_machine.ae9b341a.jpg";